import {componentsModule} from "./components/components.module";
import {landingModule} from "./landing/landing.module";
import {loginModule} from "./login/login.module";
import {sharedModule} from "./shared/shared.module";
import {filtersModule} from "./filters/filters.module";
import {appRoutes} from "./app.routes";
import * as appConfig from "./app.config";

angular.module('authentication', [
    componentsModule.name,
    sharedModule.name,
    loginModule.name,
    landingModule.name,
    filtersModule.name,
    'authentication.templates',
    'pascalprecht.translate',
    'egAngularUtils',
    'ui.router',
    'permission',
    'ui.select',
    'tableSort',
    'ngAria',
    'ngAnimate',
    'ngCookies',
    'ngMessages',
    'ngFileUpload',
    'ui.bootstrap',
    'toastr',
    'ngSanitize',
    'mwl.confirm'
])
    .config(appRoutes)
    .config(appConfig.exceptionInterceptorConfig)
    .config(appConfig.locationProviderConfig)
    .config(appConfig.translateProviderConfig)
    .config(appConfig.uibTooltipProviderConfig)
    .config(appConfig.cookiesProviderConfig)
    .run(appConfig.uiRouterStateChangeErrorHandler)
    .run(appConfig.workerNameRequiredEventListener)
    .run(appConfig.ipBlockedEventListener)
    .run(appConfig.NoInstallationUserEventListener)
;
